<template>
    <v-layout align-center style="width:100%">
        <v-flex><v-text-field v-model="pnos[0]" ref="pno0" maxlength="5" :outlined="outlined" :placeholder="placeholder" :hide-details="hideDetails" :dense="dense" @input="v => v?.length == 5 ? this.$refs.pno1.$refs.input.focus() : false" /></v-flex>
        <v-flex class="px-1"><span>-</span></v-flex>
        <v-flex><v-text-field v-model="pnos[1]" ref="pno1" maxlength="5" :outlined="outlined" :placeholder="placeholder" :hide-details="hideDetails" :dense="dense" @input="v => v?.length == 5 ? this.$refs.pno2.$refs.input.focus() : false" /></v-flex>
        <v-flex class="px-1"><span>-</span></v-flex>
        <v-flex><v-text-field v-model="pnos[2]" ref="pno2" maxlength="5" :outlined="outlined" :placeholder="placeholder" :hide-details="hideDetails" :dense="dense" @input="v => v?.length == 5 ? this.$refs.pno3.$refs.input.focus() : false" /></v-flex>
        <v-flex class="px-1"><span>-</span></v-flex>
        <v-flex><v-text-field v-model="pnos[3]" ref="pno3" maxlength="5" :outlined="outlined" :placeholder="placeholder" :hide-details="hideDetails" :dense="dense" /></v-flex>
    </v-layout>
</template>
<script>
export default {
    props: {
        value: { type: String, default: "" },
        placeholder: { type: String, default: "" },
        hideDetails: { type: Boolean, default: false },
        dense: { type: Boolean, default: false },
        outlined: { type: Boolean, default: false }
    },
    data(){
        let pno = String(this.$props.value || '').replace(/[\-]/g, '');
        return {
            pnos: [pno.substr(0, 5), pno.substr(5, 5), pno.substr(10, 5), pno.substr(15, 5)],
        }
    },
    watch: {
        value(){
            let pno = this.value;
            this.pnos = [pno.substr(0, 5), pno.substr(5, 5), pno.substr(10, 5), pno.substr(15, 5)];
        },
        pnos(){
            this.$emit("input", this.pnos.join(''));
        }
    }
}
</script>